'use client'

import { createContext, useContext } from 'react'
import { Toaster } from './toaster'
import { useToast } from '@/hook/use-toast'

const ToastContext = createContext<ReturnType<typeof useToast> | undefined>(undefined)

export function useToastContext() {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToastContext must be used within a ToastProvider')
  }
  return context
}

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const toast = useToast()

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <Toaster toasts={toast.toasts} />
    </ToastContext.Provider>
  )
} 